
import './App.css';
import Landingpage from './pages/Landingpage';
function App() {
  return (
    <div className="App">
      <Landingpage />
    </div>
  );
}

export default App;
